import { Box, Typography, styled } from '@mui/material';
import { GREEN, GREEN_DARK, MUT, MUT_DARK, MUT2 } from './tokens';

export const ReadRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'compact',
})<{ compact?: boolean }>(({ theme, compact }) => ({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  gap: '28px',
  flexWrap: 'wrap',
  background: 'linear-gradient(180deg,#f7f9fc,#fff)',
  border: '1px solid #eef2f7',
  borderRadius: '16px',
  padding: '16px 24px',
  ...theme.applyStyles('dark', {
    background:
      'linear-gradient(180deg, rgba(255,255,255,.03), rgba(255,255,255,0))',
    border: `1px solid ${theme.palette.divider}`,
  }),
  ...(compact && {
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: '12px',
    padding: '16px 18px',
  }),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: '12px',
    padding: '16px',
  },
}));

export const ReadLeft = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '14px',
  flexWrap: 'wrap',
});

export const BigCredits = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'compact',
})<{ compact?: boolean }>(({ theme, compact }) => ({
  fontSize: compact ? '30px' : '36px',
  fontWeight: 700,
  letterSpacing: '-1px',
  lineHeight: 1,
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.text.primary,
  '& img': {
    width: compact ? 28 : 32,
    height: compact ? 28 : 32,
    marginRight: compact ? '8px' : '10px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '26px',
    '& img': { width: 26, height: 26, marginRight: '8px' },
  },
}));

export const BonusPill = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  backgroundColor: '#e8f7ee',
  border: '1px solid #bfe6cf',
  color: GREEN,
  borderRadius: '999px',
  padding: '7px 14px',
  fontSize: '14px',
  fontWeight: 700,
  '& img': { width: '1em', height: '1em', flexShrink: 0 },
  ...theme.applyStyles('dark', {
    backgroundColor: 'rgba(63,204,130,.14)',
    border: '1px solid rgba(63,204,130,.35)',
    color: GREEN_DARK,
  }),
  [theme.breakpoints.down('sm')]: { fontSize: '12.5px', padding: '6px 12px' },
}));

export const ReadRight = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'compact',
})<{ compact?: boolean }>(({ theme, compact }) => ({
  textAlign: 'right',
  ...(compact && { textAlign: 'left' }),
  [theme.breakpoints.down('sm')]: { textAlign: 'left' },
}));

export const PriceRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'compact',
})<{ compact?: boolean }>(({ theme, compact }) => ({
  display: 'flex',
  alignItems: 'baseline',
  gap: '8px',
  justifyContent: 'flex-end',
  ...(compact && { justifyContent: 'flex-start' }),
  [theme.breakpoints.down('sm')]: { justifyContent: 'flex-start' },
}));

export const Price = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'compact',
})<{ compact?: boolean }>(({ theme, compact }) => ({
  fontSize: compact ? '26px' : '28px',
  fontWeight: 700,
  letterSpacing: '-.5px',
  lineHeight: 1.1,
  color: theme.palette.text.primary,
  [theme.breakpoints.down('sm')]: { fontSize: '22px' },
}));

export const StrikePrice = styled('span')(({ theme }) => ({
  fontSize: '16px',
  lineHeight: 1.1,
  color: MUT2,
  textDecoration: 'line-through',
  ...theme.applyStyles('dark', { color: theme.palette.text.secondary }),
}));

export const PerCreditNote = styled(Typography)(({ theme }) => ({
  fontSize: '13px',
  lineHeight: 1.3,
  color: MUT,
  marginTop: '3px',
  ...theme.applyStyles('dark', { color: MUT_DARK }),
  [theme.breakpoints.down('sm')]: { fontSize: '12px' },
}));
